import { render, staticRenderFns } from "./orderpressform.vue?vue&type=template&id=bd38120e&"
import script from "./orderpressform.vue?vue&type=script&lang=js&"
export * from "./orderpressform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports